export class ProviderRestoreAccountConnectivityConfig {
    'aws';
    'gcp';
    'azure';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsRestoreAccountConnectivityConfig",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpRestoreAccountConnectivityConfig",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureRestoreAccountConnectivityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ProviderRestoreAccountConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
